export { default } from './BlockTestimonialsVertical'